export const trackCat = 'Top Nav';
export const NavBarHeight = 72;
export const NavBarHeightSmScreen = 56;
//# sourceMappingURL=constants.js.map